import { api } from '@/lib/api'

/**
 * @returns {Promise<import('@/types/api').Branch[]>}
 */
export async function fetchBranches() {
  const { data } = await api.get('/admin/branches')
  return data.data.branches
}

/**
 * @param {number} branchId
 * @returns {Promise<import('@/types/api').Branch>}
 */
export async function fetchBranch(branchId) {
  const { data } = await api.get(`/admin/branches/${branchId}`)
  return data.data.branch
}

/**
 * @param {Partial<import('@/types/api').Branch>} payload
 * @returns {Promise<import('@/types/api').Branch>}
 */
export async function createBranch(payload) {
  const { data } = await api.post('/admin/branches', payload)
  return data.data.branch
}

/**
 * @param {number} branchId
 * @param {Partial<import('@/types/api').Branch>} payload
 * @returns {Promise<import('@/types/api').Branch>}
 */
export async function updateBranch(branchId, payload) {
  const { data } = await api.put(`/admin/branches/${branchId}`, payload)
  return data.data.branch
}
